import { render, staticRenderFns } from "./ModalRemove.vue?vue&type=template&id=0fd63461&scoped=true"
import script from "./ModalRemove.vue?vue&type=script&lang=js"
export * from "./ModalRemove.vue?vue&type=script&lang=js"
import style0 from "./ModalRemove.vue?vue&type=style&index=0&id=0fd63461&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd63461",
  null
  
)

export default component.exports